// Store search postcode in sessionStorage for abandoned booking capture
(function () {
  var params = new URLSearchParams(window.location.search);
  var postcode = params.get("postcode");
  if (postcode) {
    sessionStorage.setItem("searchPostcode", postcode);
  }
})();

function searchResultsScripts() {
  if (window.searchResultsInitialized) return;
  window.searchResultsInitialized = true;

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".date-btn");
    if (!btn) return;

    const card = btn.closest(".location-card");
    const fullDateSelect = card.querySelector(".date-select");
    const hash = btn.dataset.hash;

    // toggle active date
    card.querySelectorAll(".date-btn").forEach((b) => b.classList.remove("active"));
    btn.classList.add("active");

    // update date select
    if (fullDateSelect) fullDateSelect.value = btn.dataset.date;

    // show times for selected date
    card.querySelectorAll(".times").forEach((t) => t.classList.add("d-none"));
    const timesBlock = card.querySelector(".times-" + hash);
    if (timesBlock) {
      timesBlock.classList.remove("d-none");

      // auto-select first time
      const firstTime = timesBlock.querySelector(".time-badge");
      if (firstTime) firstTime.click();
    }
  });

  // Delegate clicks for time badges
  document.addEventListener("click", function (e) {
    const badge = e.target.closest(".time-badge");
    if (!badge) return;

    const card = badge.closest(".location-card");
    const form = card.querySelector("form");
    const timeLabelEl = card.querySelector(".selected-time-label");

    // toggle active
    card.querySelectorAll(".time-badge").forEach((t) => t.classList.remove("active"));
    badge.classList.add("active");

    if (timeLabelEl) timeLabelEl.textContent = badge.dataset.time;

    // update form fields
    form.querySelector("[name='apptTime']").value = badge.dataset.time;
    form.querySelector("[name='apptDate']").value = badge.dataset.date;
    form.querySelector("[name='apptId']").value = badge.dataset.id;
    form.querySelector("[name='disAccess']").value = badge.dataset.disaccess;
    form.querySelector("[name='apptType']").value = badge.dataset.appttype;
  });

  document.addEventListener("click", function (e) {
    const link = e.target.closest(".toggle-times");
    if (!link) return;

    const card = link.closest(".location-card");
    const hash = link.dataset.target;
    const container = card.querySelector(".times-" + hash + " .time-list");

    if (container.classList.contains("expanded")) {
      container.classList.remove("expanded");
      link.textContent = "View all times";
    } else {
      container.classList.add("expanded");
      link.textContent = "Show less";
    }
  });

  // Delegate change for date select dropdowns
  document.addEventListener("change", function (e) {
    const select = e.target.closest(".date-select");
    if (!select) return;

    const card = select.closest(".location-card");
    const selectedDate = select.value;
    const btn = card.querySelector(`.date-btn[data-date="${selectedDate}"]`);
    if (btn) btn.click();
  });
}

searchResultsScripts();

const urlParams = new URLSearchParams(window.location.search);
const examination = urlParams.get("examination");
const isTel = urlParams.get("tel");
const utm = urlParams.get("utm_source");
if (examination) {
  sessionStorage.setItem("isExamination", "true");
} else {
  sessionStorage.removeItem("isExamination");
}

$(document).ready(function () {
  if (window.location.hash === "#booking-section") {
    $(window).scrollTop(0);

    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $("#booking-section").offset().top - 75,
        },
        0
      );
    }, 0);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".appointment-form");
  const filterDaySelect = document.querySelector("#filter-day-select");
  if (!form) return;

  form.addEventListener("submit", function (event) {
    event.preventDefault();

    const postcode = document.querySelector('input[name="postcode"]')?.value || "";
    const distance = document.querySelector('select[name="distance"]')?.value || "";
    const disAccess = document.querySelector('input[name="disAccess"]:checked')?.value || "";

    const baseUrl = new URL(form.action, window.location.origin);
    baseUrl.searchParams.set("postcode", postcode);
    baseUrl.searchParams.set("distance", distance);
    baseUrl.searchParams.set("disAccess", disAccess);

    if (examination) {
      baseUrl.searchParams.set("examination", "true");
    }

    if (utm) {
      baseUrl.searchParams.set("utm_source", utm);
    }

    //if filters equal to 0, then instead of posting the form, redirect to the search page
    if (calculateFilters() === 0) {
      window.location.href = baseUrl.href;
      return;
    }

    form.action = baseUrl.href;
    form.submit();
  });

  filterDaySelect?.addEventListener("change", function () {
    const selectedDay = filterDaySelect.value;

    const url = new URL(form.action, window.location.origin);
    const formData = new FormData(form);
    formData.set("filter-day", selectedDay);

    url.search = new URLSearchParams(formData).toString();
    window.location.href = url.toString();
  });
});

function calculateFilters() {
  let days = $(".filter-day:not(:checked)").length;
  let am = $("input#am:not(:checked)").length;
  let pm = $("input#pm:not(:checked)").length;
  return days + am + pm;
}

$(function () {
  if (focusPostcode) {
    $("input[name=postcode]").focus();
  }

  $(".clear-filter").on("click", function () {
    $("#filter-dropdown input").prop("checked", false);
    return false;
    //add clear to query string
    urlParams.set("clearFilters", "true");
  });

  $(".select-all-filter").on("click", function () {
    $("#filter-dropdown input").prop("checked", true);
    $("#ampm-error").addClass("d-none");
    $("#day-error").addClass("d-none");
    return false;
  });

  // rehide am/pm error message on update
  $("input#am, input#am").on("change", function () {
    $("#ampm-error").addClass("d-none");
  });
  // rehide day message on update
  $(".filter-day").on("change", function () {
    $("#day-error").addClass("d-none");
  });

  $("#filterModal").on("hide.bs.modal", function (event) {
    var isValid = true;

    // neither am or pm checked
    if (!$("input#am").prop("checked") && !$("input#pm").prop("checked")) {
      isValid = false;
      $("#ampm-error").removeClass("d-none");
    }

    // no days selected
    if ($(".filter-day:checked").length <= 0) {
      isValid = false;
      $("#day-error").removeClass("d-none");
    }

    if (!isValid) {
      event.preventDefault(); // Prevent modal from closing
      return false;
    }

    //calculate the number of filters checked
    var filtersChecked = calculateFilters();
    //

    // is valid. Trigger a search!
    $(".appointment-form").submit();
  });

  // update the count
  var filtersChecked = calculateFilters();
  if (filtersChecked > 0) {
    $(".indicator.filters").html(filtersChecked).removeClass("d-none");
  }
});
